export default "__VITE_ASSET__BgwHpPfE__"